import React, { useCallback, useMemo } from 'react'
import * as styles from '../checkoutModal.module.scss'
import { Dropdown, Input } from '../../common/form/fields'
import { ReturnViewProps } from '../actionsWorkflow.type'
import { Option } from '../../common/form/fields/dropdown/types'
import { convertWarehouseOptionToOption } from '../../common/crudItems/inventory/helpers'
import { Col, Row } from 'react-grid-system'

export const ReturnView = ({
   validationErrors,
   handleDropdownChange,
   handleCommentChange,
   warehouseOptions,
   selectedReturnWarehouse,
   enableLocationTracking,
}: ReturnViewProps) => {
   const handleWarehouseChange = useCallback(
      (option: Option) => handleDropdownChange('Warehouse', option),
      [handleDropdownChange]
   )

   const handleCommentFieldChange = useCallback(
      (comment) => handleCommentChange('Comment', comment),
      [handleCommentChange]
   )

   const options = useMemo(
      () =>
         warehouseOptions?.length > 0
            ? warehouseOptions.map(convertWarehouseOptionToOption)
            : [],
      [warehouseOptions]
   )

   const heading = useMemo(
      () =>
         enableLocationTracking
            ? 'Confirm Return and Warehouse'
            : 'Confirm Return',
      [enableLocationTracking]
   )

   const message = useMemo(
      () =>
         enableLocationTracking
            ? 'I confirm the Items have been physically returned to this Warehouse:'
            : 'Are you sure all of the selected items have been returned to its original warehouse?',
      [enableLocationTracking]
   )

   return (
      <>
         <input type="hidden" name="Return" value="True" />
         <div className={styles.centeredViewWrapper}>
            <div className={styles.centeredViewHeading}>{heading}</div>
            <p className={styles.centeredViewMessage}>{message}</p>
            <Row gutterWidth={20}>
               {enableLocationTracking && (
                  <Col md={6}>
                     <Dropdown
                        error={validationErrors?.Warehouse}
                        id="Warehouse"
                        name="Warehouse"
                        defaultValue={selectedReturnWarehouse}
                        placeholder="Home Warehouse Location"
                        onChange={handleWarehouseChange}
                        options={options}
                        isMulti={false}
                        withWrappers
                        isClearable={false}
                        menuPosition="fixed"
                     />
                  </Col>
               )}
               <Col>
                  <Input
                     id="Comment"
                     label="Comment (optional)"
                     onChange={handleCommentFieldChange}
                  />
               </Col>
            </Row>
         </div>
      </>
   )
}
